import type { ReactNode } from 'react';
import { Button } from './Button';
import { cx } from './cx';
import { Spinner } from './Spinner';

/** Empty state: o que é · porque importa · próximo passo (docs/design-system.md §7). */
export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx('mx-auto flex max-w-md flex-col items-center px-6 py-16 text-center', className)}>
      {icon && <div className="mb-4 text-text-3">{icon}</div>}
      <h2 className="text-lg font-semibold text-text-1">{title}</h2>
      <p className="mt-2 text-[15px] leading-relaxed text-text-2">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function ErrorState({
  title = 'Não foi possível carregar esta página',
  description = 'Verifique a ligação e tente novamente.',
  onRetry,
  requestId,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
  requestId?: string | undefined;
}) {
  return (
    <div role="alert" className="mx-auto flex max-w-md flex-col items-center px-6 py-16 text-center">
      <h2 className="text-lg font-semibold text-text-1">{title}</h2>
      <p className="mt-2 text-[15px] leading-relaxed text-text-2">{description}</p>
      {onRetry && (
        <Button variant="secondary" className="mt-6" onClick={onRetry}>
          Tentar novamente
        </Button>
      )}
      {requestId && <p className="mt-4 text-xs text-text-3">Referência: {requestId}</p>}
    </div>
  );
}

export function LoadingState({ label = 'A carregar…' }: { label?: string }) {
  return (
    <div role="status" className="flex items-center justify-center gap-3 py-16 text-text-2">
      <Spinner className="size-5" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cx('animate-pulse rounded-input bg-surface-2', className)} />;
}
